/** meeting app 环境的导航菜单 */
'use client';
import React, { useState, useEffect, useCallback, FC, useMemo } from 'react';
import { Drawer } from '@tencent/calendar-web-component-mobile';
import ActiveLink from './ActiveLink';
import style from './index.module.scss';
import { useEntry } from '@hooks/useEntry';
import useLatest from 'ahooks/lib/useLatest';

const disableMenuIcon = () => {
  wemeet.ui.setHeaderView({
    mixBackExitButton: true,
    showRefresh: false,
    rightButton: {
      text: '',
    },
  });
};

interface Props {
  /** 页面标题 */
  title?: string;
  /** 导航栏 */
  items?: {
    /** 菜单项ID */
    id: string;
    title: string;
    href: string;
    /** 用replace而不是push/goto */
    replace?: boolean;
    /** 是否是应用内, 如果是则使用 router.push */
    isInApp?: boolean;
    /** 别名, 用于高亮. 例如 [/home, /index] 都会使此链接高亮 */
    alias?: string[];
  }[];
}

// const defaultTitle = '活动广场';
const defaultNavItems: Props['items'] = [
  { id: 'square', title: '活动广场', href: '/events/square' },
  { id: 'my', title: '我的活动', href: '/events/my' },
  { id: 'host', title: '活动空间', href: '/home', alias: ['/space', '/index'], isInApp: true },
];

const NavDialog: FC<Props> = ({ items = defaultNavItems }) => {
  const [visible, setVisible] = useState(false);

  const toggleMenu = useCallback((show = false) => {
    if (typeof wemeet === 'undefined') return;
    if (sessionStorage?.navDialogDisable) {
      disableMenuIcon();
      return;
    }
    wemeet?.ui?.setHeaderView({
      mixBackExitButton: true,
      showRefresh: false,
      // 这个值如果不传递，那打开页面的时候title是什么它就会重置成什么, 可能是app的bug
      title: '活动空间',
      rightButton: {
        // 1分享 2设置 3更多  4和5 是3.8版本新增的图标 4菜单 5关闭
        icon: hideMenu.current ? 0 : 4,
        onClick() {
          if (hideMenu.current) return;
          // beaconReport('eventplace_public_mobile_roleshuffle_null_null_click');
          setVisible(!show);
        },
      },
    });
  }, []);

  useEffect(
    () => () => {
      if (typeof wemeet === 'undefined') return;
      disableMenuIcon();
    },
    [],
  );

  const close = useCallback(() => {
    setVisible(false);
  }, []);

  const { showHost, showLobby } = useEntry() || {};
  const itemsFiltered = useMemo(
    () =>
      items.filter((x) => {
        if (x.id === 'square') {
          return showLobby;
        }
        if (x.id === 'host') {
          return showHost;
        }
        return true;
      }),
    [items, showHost, showLobby],
  );
  const hideMenu = useLatest(itemsFiltered.length < 2);

  useEffect(() => {
    toggleMenu(visible);
  }, [visible, hideMenu.current]);

  return (
    <Drawer
      visible={visible}
      direction="top"
      className={style['nav-dialog']}
      hasMask
      title={null}
      onClose={close}
    >
      {itemsFiltered?.map((item) => (
        <ActiveLink
          key={item.href}
          className={style['nav-dialog-item']}
          activeClassName={style.active}
          {...item}
        >
          {item.title}
          <i className="iconfont icon-arrow-right" />
        </ActiveLink>
      ))}
    </Drawer>
  );
};

export default NavDialog;
